const Send2Icon = ({ viewBox = "0 0 24 24", className = "hayley-h-6 hayley-w-6 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path
        d="M9.85214 9.87817L8.22139 5.21924L21.8979 12.1621L8.00099 18.6525L10.5857 11.9765L14.8278 12.0461"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Send2Icon;
